/**
 * API Module
 * Main entry point for all API functionality
 *
 * Usage:
 *
 * // Import HTTP client
 * import { http } from './api';
 * const response = await http.get('/endpoint');
 *
 * // Import specific service
 * import { authService, jobsService } from './api';
 * await authService.login(email, password);
 * await jobsService.getActiveJobs({ page: 0 });
 *
 * // Import individual functions
 * import { login, getActiveJobs } from './api';
 * await login(email, password);
 *
 * // Import config
 * import { API_URL, ENDPOINTS } from './api';
 */

// Imports for default export
import httpClient from './client';
import authSvc from './services/auth';
import jobsSvc from './services/jobs';
import companiesSvc from './services/companies';
import chatSvc from './services/chat';
import gamesSvc from './services/games';
import referenceSvc from './services/reference';

// HTTP Client
export { default as http } from './client';
export {
  ApiError,
  getToken,
  setToken,
  removeToken,
  addRequestInterceptor,
  addResponseInterceptor
} from './client';

// Configuration
export {
  API_BASE_URL,
  API_VERSION,
  API_URL,
  REQUEST_TIMEOUT,
  DEFAULT_HEADERS,
  TOKEN_KEY,
  REFRESH_TOKEN_KEY,
  USER_KEY,
  ENDPOINTS
} from './config';

// Services
export {
  authService,
  jobsService,
  companiesService,
  chatService,
  gamesService,
  referenceService
} from './services';

// Re-export all individual service functions
export * from './services';

// Default export with all services
export default {
  http: httpClient,
  auth: authSvc,
  jobs: jobsSvc,
  companies: companiesSvc,
  chat: chatSvc,
  games: gamesSvc,
  reference: referenceSvc
};
